import request from '@/utils/request'

//02新增购物车列表
export function AddShoppingCartApi(data) {
  return request({
    url: 'v1/web/shopping/cart/add',
    method: 'POST',
    data
  })
}

//01获取购物车列表
export function getShoppingCartApi() {
  return request({
    url: 'v1/web/shopping/cart/list',
    method: 'GET'
  })
}

// 06购物车购买

export function PurchaseCartApi(data) {
  return request({
    url: 'v1/web/shopping/cart/purchase',
    method: 'POST',
    data
  })
}

// 07立即购买
export function PurchaseProductApi(data) {
  return request({
    url: 'v1/web/product/purchase',
    method: 'POST',
    data
  })
}

// 删除购物车
export function deleteShoppingCartApi(data) {
  return request({
    url: 'v1/web/shopping/cart/delete',
    method: 'POST',
    data
  })
}

// 05批量删除购物车商品
export function deleteBatchShoppingCartApi(data) {
  return request({
    url: 'v1/web/shopping/cart/batch/delete',
    method: 'POST',
    data
  })
}
